var React = require('react');

function ContentPlayHollowAlt (props) {
    return React.createElement("svg",props,[React.createElement("polygon",{"points":"15.36 11.34 15.36 23.66 22.75 17.5 15.36 11.34","key":0}),React.createElement("circle",{"fill":"none","stroke":"currentColor","strokeMiterlimit":"10","cx":"17.5","cy":"17.5","r":"15.66","key":1})]);
}

ContentPlayHollowAlt.defaultProps = {"role":"presentation","id":"other","viewBox":"0 0 35 35"};

module.exports = ContentPlayHollowAlt;

ContentPlayHollowAlt.default = ContentPlayHollowAlt;
